import { cacheWithMap, createMap, deleteFromMap } from "./map.js";
import { setTimeout } from "./window.js";
/**
 * @template T
 */
export const createCache = () => {
    /**
     * @type {Promise<T> | undefined}
     */
    let value;
    let timeout = 0;
    const clear = () => (value = undefined);
    /**
     * @param {(setExpire: (expireTimeout: number) => void) => Promise<T>} callback
     */
    return async (callback) => (value ??= callback((expireTimeout) => (timeout = expireTimeout)).finally(() => {
        if (timeout <= 0) {
            clear();
        }
        else if (timeout < 2 ** 32) {
            setTimeout(clear, timeout);
        }
    }));
};
/**
 * @template K
 * @template V
 */
export const createCacheMap = () => {
    /**
     * @type {Map<K, Promise<V>>}
     */
    const cache = createMap();
    /**
     * @param {K} key
     * @param {(setExpire: (expireTimeout: number) => void) => Promise<V>} callback
     */
    return async (key, callback) => cacheWithMap(cache, key, () => {
        let timeout = 0;
        const clear = () => deleteFromMap(cache, key);
        return callback((expireTimeout) => (timeout = expireTimeout)).finally(() => {
            if (timeout <= 0) {
                clear();
            }
            else if (timeout < 2 ** 32) {
                setTimeout(clear, timeout);
            }
        });
    });
};
